// extracted by mini-css-extract-plugin
export default {"container":"ZegoLoading_container__30IEp","loading":"ZegoLoading_loading__wFDPM","myRotate":"ZegoLoading_myRotate__pgdGs"};